import { isArray, isString, uniq } from 'lodash';
export const mapTags = (value) => {
    if (isString(value)) {
        return [value === null || value === void 0 ? void 0 : value.trim()];
    }
    if (isArray(value)) {
        return uniq((value !== null && value !== void 0 ? value : [])
            .filter((tag) => isString(tag) && tag.trim().length > 0)
            .map((tag) => tag.trim()));
    }
    return [];
};
